import { render } from "./CatErpView.vue?vue&type=template&id=04f15514&scoped=true"
import script from "./CatErpView.vue?vue&type=script&lang=js"
export * from "./CatErpView.vue?vue&type=script&lang=js"

import "./CatErpView.vue?vue&type=style&index=0&id=04f15514&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04f15514"]])

export default __exports__